import styled, { useTheme } from 'styled-components';
import {
  footNoteMediumStyle,
  Link,
  Text,
} from '@sparknz/spark-pattern-library';

const StyledLink = styled(Link)`
  ${footNoteMediumStyle}
`;

const HCaptchaDisclaimerText = () => {
  const {
    palette: { baseColors },
  } = useTheme();

  return (
    <Text variant="footnoteMedium" color={baseColors.mawheranui}>
      This site is protected by hCaptcha and its{' '}
      <StyledLink
        href="https://www.hcaptcha.com/privacy"
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy
      </StyledLink>{' '}
      and{' '}
      <StyledLink
        href="https://www.hcaptcha.com/terms"
        target="_blank"
        rel="noreferrer"
      >
        Terms of Service
      </StyledLink>{' '}
      apply.
    </Text>
  );
};

export default HCaptchaDisclaimerText;
